<template>
  <div class="error-page">
    <div class="error-code">4<span>0</span>4</div>
    <div class="error-desc">啊哦~ 你所访问的页面不存在</div>
    <div class="error-handle">
      <router-link to="/">
        <el-button type="primary" size="large">返回首页</el-button>
      </router-link>
      <el-button class="error-btn" type="primary" size="large" @click="goBack">返回上一页</el-button>
        <el-button class="error-btn" type="primary" size="large" @click="logout">清除登录缓存</el-button>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    logout() {
      this.$store
        .dispatch('user/logout')
        .then(() => {
          this.$router.replace('/login')
          Cookies.remove('vue_admin_token')
          localStorage.setItem('buttonPerms', '')
          localStorage.setItem('permName', '')
          localStorage.setItem('clickIndex', 0)
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
  .error-page {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #f3f3f3;
    box-sizing: border-box;
  }

  .error-code {
    line-height: 1;
    font-size: 250px;
    font-weight: bolder;
    color: #2d8cf0;
    width: auto;
  }

  .error-code span {
    color: #00a854;
  }

  .error-desc {
    font-size: 30px;
    color: #777;
  }

  .error-handle {
    margin-top: 30px;
    padding-bottom: 200px;
  }

  .error-btn {
    margin-left: 100px;
  }

  @media (max-width: 768px) {
    .error-desc {
      font-size: 20px;
    }

    .error-code {
      font-size: 200px;
    }
  }
</style>
